import { IConfirmDialogProps } from 'Components/Core';
import React from 'react';
import { GridColCellAlignments } from '../Core/getColCellAlignment';
import { GridColWidths } from '../Core/getColWidth';

// This tries to help enforce Fields being passed into the grid because the custom tabbing code relies on it.
// As it turns out any element including <span> is apparently a valid type here, so there's some additional validation
// at runtime.
export type IGridData = (React.ReactElement | null | undefined)[][];

export type GridTabDirection = 'horizontal' | 'vertical';

/** Properties for either a row or column */
export interface IVectorProps {
  /** A key to help React reconcile DOM components. Must be unique and stable.
   * If not provided, the key will be the index of the row/column
   */
  key?: string;
}

export interface IGridProps {
  center?: boolean;
  colHeaders?: Array<JSX.Element | string | number | null | undefined>;
  colWidths?: GridColWidths;
  colCellAlignments?: GridColCellAlignments;
  cornerHeader?: string | null | undefined;
  data?: IGridData;
  disabled?: boolean;
  hiddenRows?: Array<number | null | undefined>;
  hiddenCols?: Array<number | null | undefined>;
  onReceivedData?: (data: IGridData, hiddenRows?: Array<number | null | undefined>) => void;
  removeConfirm?: IConfirmDialogProps;
  rowHeaders?: Array<string | null | undefined>;
  rowHeaderWidth?: number | 'auto';
  tabDirection?: GridTabDirection;
}

export interface IHorizontalGridProps extends IGridProps {
  onCreateCol?: () => void;
  onRemoveCol?: (col: number) => void;
  scrollLinkId?: string;
  columns?: IHorizontalGridColumnProps[];
  rows?: IVectorProps[];
}

export interface IHorizontalGridColumnProps extends IVectorProps {
  preventRemoveCol?: boolean;
  dim?: boolean;
}

export enum DateTimeStyle {
  Separate,
  Combined,
}

/** Width (in pixels) for columns that have a _DateTime_ input displayed to the nearest minute (default) */
export const DATETIME_INPUT_COLUMN_WIDTH = 220;
/** Width (in pixels) for columns that have a _DateTime_ input displayed to the nearest second */
export const DATETIME_INPUT_COLUMN_WIDTH_SEC = 245;
/** Width (in pixels) for columns that have a _DateTime_ input displayed to the nearest millisecond */
export const DATETIME_INPUT_COLUMN_WIDTH_MS = 280;
